import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext.tsx';

export enum GetPastSurveyCacheKey {
  PastSurvey = 'PAST_SURVEYS',
}

export const useGetPastSurveys = (teamId: number) => {
  const { fetchPastSurveys } = useServicesContext();
  return useQuery({
    queryKey: [GetPastSurveyCacheKey.PastSurvey, teamId],
    queryFn: async () => {
      return fetchPastSurveys(teamId!);
    },
    refetchInterval: 60000,
    enabled: Boolean(teamId),
  });
};
